import { SkillForm } from "@/core/skillForms/types";
import { feeAgreementSkillStep1 } from "./step1";
import { feeAgreementSkillStep2 } from "./step2";

export const feeAgreementSkillForm: SkillForm = {
  skillId: "fee_agreement",
  title: "Elaborar contrato de honorários advocatícios",
  steps: [feeAgreementSkillStep1, feeAgreementSkillStep2],
};
